"use client";

import { create } from "zustand";
import type { ICountry } from "@/lib/shared/constants";
import { defaultCountry } from "@/lib/shared/constants";

const STORAGE_KEY = "selectedCountryCode";

interface CountryStore {
  country: ICountry;
  setCountry: (countryCode: string) => void;
  countries?: ICountry[];
  setCountries: (countries: ICountry[]) => void;
}

/**
 * Country/Currency store
 * Manages selected country and currency conversion.
 * Persists selection to localStorage for returning users.
 */
export const useCountryStore = create<CountryStore>((set, get) => ({
  countries: undefined,
  setCountries: (countries: ICountry[]) => {
    set({ countries });
  },
  country: defaultCountry,
  setCountry: (countryCode: string) => {
    const country = get().countries?.find((c) => c.countryCode === countryCode);
    if (country) {
      if (typeof window !== "undefined") {
        localStorage.setItem(STORAGE_KEY, countryCode);
      }
      set({ country });
    }
  },
}));

export { STORAGE_KEY as COUNTRY_STORAGE_KEY };
